module.exports = __webpack_public_path__ + "static/media/Lato-Medium.863b7dcd.ttf";